import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// TICKET_UPDATE_ALARM

const mutation = gql`
  mutation ticketUpdateAlarm(
    $ticket_id: ID!
    $alarm: TicketAlarmAttributesInput
  ) {
    ticketUpdateAlarm(ticket_id: $ticket_id, alarm: $alarm) {
      id
      alarm {
        datetime
        notes
      }
    }
  }
`

export default function useTicketUpdateAlarm(message) {
  const { onMutate: onUpdateTicketAlarm, loading } = useSafeRunMutation({
    mutation,
    successMessage: message,
    responsePath: 'updateTicketAlarm'
  })
  return { onUpdateTicketAlarm, loading }
}
